import React, { useMemo } from 'react';
import { MdOutlineBolt, MdOutlineSatelliteAlt } from 'react-icons/md';
import { useSelector } from 'react-redux';

import { Top as TopUI, TopNotificationCount, TopStatusValue } from '@/components/ui/dashboard/Top';

const Top = ({ robot }) => {
  const batteryStatus = useSelector((state) => state.telemetry[robot.id].batteryStatus);
  const gpsRaw = useSelector((state) => state.telemetry[robot.id].gpsRaw);

  const voltage = useMemo(() => {
    if (!batteryStatus) return;

    return (batteryStatus.voltage / 1000).toFixed(1);
  }, [batteryStatus]);

  return (
    <TopUI agentType={robot.model.agentType} owned={robot.isOwned} robotId={robot.id}>
      <TopStatusValue Icon={MdOutlineBolt} value={voltage} unit="V" />
      <TopStatusValue Icon={MdOutlineSatelliteAlt} value={gpsRaw?.satellitesVisible} style={{ gap: 4 }} />
      <TopNotificationCount robotId={robot.id} />
    </TopUI>
  );
};

export default Top;
